define.alias("ember-drag-sort/components/drag-sort-list", "calendar/components/drag-sort-list");